// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__ViewInAppPopup__UkGeA","pointerBox":"pointerBox__ViewInAppPopup__UkGeA"};